/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultOperationPeriod
 */
export interface BatchRunResultOperationPeriod {
    /**
     * 
     * @type {Date}
     * @memberof BatchRunResultOperationPeriod
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof BatchRunResultOperationPeriod
     */
    endDate: Date;
}

/**
 * Check if a given object implements the BatchRunResultOperationPeriod interface.
 */
export function instanceOfBatchRunResultOperationPeriod(value: object): value is BatchRunResultOperationPeriod {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function BatchRunResultOperationPeriodFromJSON(json: any): BatchRunResultOperationPeriod {
    return BatchRunResultOperationPeriodFromJSONTyped(json, false);
}

export function BatchRunResultOperationPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultOperationPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
    };
}

export function BatchRunResultOperationPeriodToJSON(json: any): BatchRunResultOperationPeriod {
    return BatchRunResultOperationPeriodToJSONTyped(json, false);
}

export function BatchRunResultOperationPeriodToJSONTyped(value?: BatchRunResultOperationPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start_date': ((value['startDate']).toISOString().substring(0,10)),
        'end_date': ((value['endDate']).toISOString().substring(0,10)),
    };
}

